// src/screens/admin/VuelosRutasPublicadas.jsx
// Sub-sección B del panel "Vuelos Guyana": todas las rutas ya publicadas,
// agrupadas primero por destino y luego por ciudad de salida dentro de cada
// destino -- así es igual de fácil encontrar y gestionar rutas de un
// destino puntual que en el flujo del cliente. Permite activar/desactivar
// (caso de rutas duplicadas entre proveedores), editar cupos por fecha y
// el campo Equipaje -- todo fuera del flujo de "pegar mensaje".
import React, { useState, useEffect } from 'react';
import { toast } from '../../components/UI';
import {
  getRutasAdmin, setRutaVueloActiva, setRutaAdmiteUsdCuba, setRutaSoloUsdCuba, actualizarPorcentajeUsdCubaRuta, actualizarCuposFechaVuelo, actualizarEquipajeRutaVuelo,
  actualizarPrecioPromoFechaVuelo, actualizarCuposPromoFechaVuelo, calcCuposPromoRestantes,
  eliminarFechaVuelo, DESTINO_CATEGORIAS, normalizeKey, actualizarPrecioRutaVuelo, agregarFechaVuelo,
  actualizarEscalonesRutaVuelo, calcPrecioZelleFecha, calcularAnclaRuta, actualizarPreciosEdadesRutaVuelo,
  eliminarRutaVuelo, actualizarPrecioIdaVueltaRutaVuelo,
} from '../../services/vuelosGuyanaService';

function EscalonesBlock({ ruta, onChanged }) {
  const conNinos = ruta.categorias === 'adulto_nino_infante';
  const [escalonado, setEscalonado] = useState(!!ruta.escalonado);
  const [barato, setBarato] = useState(ruta.precio_zelle_barato ?? '');
  const [medio, setMedio] = useState(ruta.precio_zelle_medio ?? '');
  const [caro, setCaro] = useState(ruta.precio_zelle_caro ?? '');
  const [diasLejos, setDiasLejos] = useState(ruta.dias_corte_lejos ?? 30);
  const [diasCerca, setDiasCerca] = useState(ruta.dias_corte_cerca ?? 7);
  const [ninoBarato, setNinoBarato] = useState(ruta.precio_nino_barato ?? '');
  const [ninoMedio, setNinoMedio] = useState(ruta.precio_nino_medio ?? '');
  const [ninoCaro, setNinoCaro] = useState(ruta.precio_nino_caro ?? '');
  const [saving, setSaving] = useState(false);

  const ancla = calcularAnclaRuta(ruta.fechas);

  const handleGuardar = async () => {
    if (escalonado && (barato === '' || medio === '' || caro === '')) {
      toast('Completa los 3 precios del escalón.', 'error');
      return;
    }
    setSaving(true);
    try {
      await actualizarEscalonesRutaVuelo(ruta.id, {
        escalonado, precioBarato: barato, precioMedio: medio, precioCaro: caro,
        diasLejos, diasCerca,
        precioNinoBarato: ninoBarato, precioNinoMedio: ninoMedio, precioNinoCaro: ninoCaro,
      });
      toast('Escalones actualizados ✅');
      onChanged();
    } catch { toast('Error al actualizar los escalones.', 'error'); }
    setSaving(false);
  };

  return (
    <div style={{ border: '1px solid var(--navy-border)', borderRadius: 10, padding: 10, marginBottom: 12 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
        <span style={{ fontSize: 10, color: 'var(--muted)', fontWeight: 700, letterSpacing: 0.5 }}>TARIFA ESCALONADA POR FECHA</span>
        <button onClick={() => setEscalonado((v) => !v)} style={{
          fontSize: 11, fontWeight: 700, borderRadius: 20, padding: '4px 10px',
          background: escalonado ? 'rgba(0,196,140,0.15)' : 'var(--navy-card)',
          color: escalonado ? 'var(--success)' : 'var(--muted)',
          border: `1px solid ${escalonado ? 'rgba(0,196,140,0.4)' : 'var(--navy-border)'}`,
        }}>{escalonado ? '✅ Activada' : '⛔ Precio fijo'}</button>
      </div>
      {escalonado && (
        <>
          <p style={{ fontSize: 10, color: 'var(--muted)', marginBottom: 8 }}>
            Ancla (primera fecha activa de esta ruta): <strong style={{ color: 'var(--off-white)' }}>{ancla || '—'}</strong>
          </p>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginBottom: 8 }}>
            <div style={{ flex: '1 0 80px' }}>
              <label style={{ fontSize: 9, color: 'var(--success)' }}>Barato (&gt;{diasLejos}d)</label>
              <input type="number" inputMode="decimal" value={barato} onChange={(e) => setBarato(e.target.value)} style={{ width: '100%', padding: '6px 10px', fontSize: 12 }} />
            </div>
            <div style={{ flex: '1 0 80px' }}>
              <label style={{ fontSize: 9, color: 'var(--gold)' }}>Medio</label>
              <input type="number" inputMode="decimal" value={medio} onChange={(e) => setMedio(e.target.value)} style={{ width: '100%', padding: '6px 10px', fontSize: 12 }} />
            </div>
            <div style={{ flex: '1 0 80px' }}>
              <label style={{ fontSize: 9, color: 'var(--error)' }}>Caro (&lt;{diasCerca}d)</label>
              <input type="number" inputMode="decimal" value={caro} onChange={(e) => setCaro(e.target.value)} style={{ width: '100%', padding: '6px 10px', fontSize: 12 }} />
            </div>
          </div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginBottom: conNinos ? 8 : 10 }}>
            <div style={{ flex: '1 0 100px' }}>
              <label style={{ fontSize: 9, color: 'var(--muted)' }}>Corte "lejos" (días)</label>
              <input type="number" inputMode="numeric" value={diasLejos} onChange={(e) => setDiasLejos(e.target.value)} style={{ width: '100%', padding: '6px 10px', fontSize: 12 }} />
            </div>
            <div style={{ flex: '1 0 100px' }}>
              <label style={{ fontSize: 9, color: 'var(--muted)' }}>Corte "cerca" (días)</label>
              <input type="number" inputMode="numeric" value={diasCerca} onChange={(e) => setDiasCerca(e.target.value)} style={{ width: '100%', padding: '6px 10px', fontSize: 12 }} />
            </div>
          </div>
          {conNinos && (
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginBottom: 10 }}>
              <div style={{ flex: '1 0 80px' }}>
                <label style={{ fontSize: 9, color: 'var(--success)' }}>Niño barato</label>
                <input type="number" inputMode="decimal" value={ninoBarato} onChange={(e) => setNinoBarato(e.target.value)} style={{ width: '100%', padding: '6px 10px', fontSize: 12 }} />
              </div>
              <div style={{ flex: '1 0 80px' }}>
                <label style={{ fontSize: 9, color: 'var(--gold)' }}>Niño medio</label>
                <input type="number" inputMode="decimal" value={ninoMedio} onChange={(e) => setNinoMedio(e.target.value)} style={{ width: '100%', padding: '6px 10px', fontSize: 12 }} />
              </div>
              <div style={{ flex: '1 0 80px' }}>
                <label style={{ fontSize: 9, color: 'var(--error)' }}>Niño caro</label>
                <input type="number" inputMode="decimal" value={ninoCaro} onChange={(e) => setNinoCaro(e.target.value)} style={{ width: '100%', padding: '6px 10px', fontSize: 12 }} />
              </div>
            </div>
          )}
        </>
      )}
      <button onClick={handleGuardar} disabled={saving} style={{ background: 'var(--navy)', border: '1px solid var(--orange)', color: 'var(--orange)', borderRadius: 8, padding: '6px 14px', fontSize: 12, fontWeight: 700, width: '100%' }}>
        {saving ? '...' : 'Guardar escalones'}
      </button>
    </div>
  );
}

function RutaRow({ ruta, onChanged, abiertaInicial = false }) {
  const [abierta, setAbierta] = useState(abiertaInicial);
  const conNinos = ruta.categorias === 'adulto_nino_infante';
  const [equipaje, setEquipaje] = useState(ruta.equipaje || '');
  const [precioBase, setPrecioBase] = useState(ruta.precio_base_usd ?? '');
  const [precioZelle, setPrecioZelle] = useState(ruta.precio_zelle ?? '');
  const [precioBaseNino, setPrecioBaseNino] = useState(ruta.precio_base_nino ?? '');
  const [precioNino, setPrecioNino] = useState(ruta.precio_nino ?? '');
  const [precioBaseInfante, setPrecioBaseInfante] = useState(ruta.precio_base_infante ?? '');
  const [precioInfante, setPrecioInfante] = useState(ruta.precio_infante ?? '');
  const [savingActiva, setSavingActiva] = useState(false);
  const [savingEliminar, setSavingEliminar] = useState(false);
  const [savingUsdCuba, setSavingUsdCuba] = useState(false);
  const [savingSoloUsd, setSavingSoloUsd] = useState(false);
  const [pctRuta, setPctRuta] = useState(ruta.porcentaje_usd_cuba_ruta ?? '');
  const [savingPct, setSavingPct] = useState(false);
  const [savingEquipaje, setSavingEquipaje] = useState(false);
  const [savingPrecio, setSavingPrecio] = useState(false);
  const [savingPrecioEdades, setSavingPrecioEdades] = useState(false);
  const [precioBaseIdaVuelta, setPrecioBaseIdaVuelta] = useState(ruta.precio_base_ida_vuelta ?? '');
  const [precioZelleIdaVuelta, setPrecioZelleIdaVuelta] = useState(ruta.precio_zelle_ida_vuelta ?? '');
  const [savingIdaVuelta, setSavingIdaVuelta] = useState(false);
  const [cuposDraft, setCuposDraft] = useState({});
  const [promoDraft, setPromoDraft] = useState({});
  const [cuposPromoDraft, setCuposPromoDraft] = useState({});
  const [diasPromoDraft, setDiasPromoDraft] = useState({});
  const [nuevaFecha, setNuevaFecha] = useState('');
  const [nuevaFechaCupos, setNuevaFechaCupos] = useState('');
  const [savingNuevaFecha, setSavingNuevaFecha] = useState(false);

  const handleToggleActiva = async () => {
    setSavingActiva(true);
    try {
      await setRutaVueloActiva(ruta.id, !ruta.activa);
      onChanged();
    } catch { toast('Error al actualizar.', 'error'); }
    setSavingActiva(false);
  };

  const handleEliminarRuta = async () => {
    if (!window.confirm(`¿Borrar esta ruta del todo (${ruta.ciudad_salida} → ${ruta.destino}, ${ruta.aerolinea || 'sin aerolínea'})? Esto borra también todas sus fechas. No se puede deshacer.`)) return;
    setSavingEliminar(true);
    try {
      await eliminarRutaVuelo(ruta.id);
      toast('Ruta eliminada ✅');
      onChanged();
    } catch { toast('Error al eliminar la ruta.', 'error'); }
    setSavingEliminar(false);
  };

  const handleToggleUsdCuba = async () => {
    setSavingUsdCuba(true);
    try {
      await setRutaAdmiteUsdCuba(ruta.id, !ruta.admite_usd_cuba);
      onChanged();
    } catch { toast('Error al actualizar.', 'error'); }
    setSavingUsdCuba(false);
  };

  const handleGuardarPctRuta = async () => {
    setSavingPct(true);
    try {
      await actualizarPorcentajeUsdCubaRuta(ruta.id, pctRuta);
      toast(pctRuta === '' ? `% propio quitado: usa el ${ruta.proveedor_porcentaje_usd_cuba}% del proveedor ✅` : '% de USD Cuba de la ruta actualizado ✅');
      onChanged();
    } catch { toast('Error al actualizar el %.', 'error'); }
    setSavingPct(false);
  };

  const handleToggleSoloUsd = async () => {
    setSavingSoloUsd(true);
    try {
      await setRutaSoloUsdCuba(ruta.id, !ruta.solo_usd_cuba);
      onChanged();
    } catch { toast('Error al actualizar.', 'error'); }
    setSavingSoloUsd(false);
  };

  const handleGuardarEquipaje = async () => {
    setSavingEquipaje(true);
    try {
      await actualizarEquipajeRutaVuelo(ruta.id, equipaje);
      toast('Equipaje actualizado ✅');
    } catch { toast('Error al actualizar equipaje.', 'error'); }
    setSavingEquipaje(false);
  };

  const handleGuardarPrecio = async () => {
    if (precioBase === '' || precioZelle === '') {
      toast('Completa costo y precio Zelle.', 'error');
      return;
    }
    setSavingPrecio(true);
    try {
      await actualizarPrecioRutaVuelo(ruta.id, precioBase, precioZelle);
      toast('Precio actualizado ✅');
      onChanged();
    } catch { toast('Error al actualizar el precio.', 'error'); }
    setSavingPrecio(false);
  };

  const handleGuardarIdaVuelta = async () => {
    setSavingIdaVuelta(true);
    try {
      await actualizarPrecioIdaVueltaRutaVuelo(ruta.id, precioBaseIdaVuelta, precioZelleIdaVuelta);
      toast('Precio de ida y vuelta actualizado ✅');
      onChanged();
    } catch { toast('Error al actualizar el precio de ida y vuelta.', 'error'); }
    setSavingIdaVuelta(false);
  };

  const handleGuardarPrecioEdades = async () => {
    setSavingPrecioEdades(true);
    try {
      await actualizarPreciosEdadesRutaVuelo(ruta.id, precioBaseNino, precioNino, precioBaseInfante, precioInfante);
      toast('Precios de niño/infante actualizados ✅');
      onChanged();
    } catch { toast('Error al actualizar precios de niño/infante.', 'error'); }
    setSavingPrecioEdades(false);
  };

  const handleAgregarFecha = async () => {
    if (!nuevaFecha) { toast('Elige una fecha.', 'error'); return; }
    setSavingNuevaFecha(true);
    try {
      await agregarFechaVuelo(ruta.id, nuevaFecha, nuevaFechaCupos === '' ? null : nuevaFechaCupos);
      toast('Fecha agregada ✅');
      setNuevaFecha('');
      setNuevaFechaCupos('');
      onChanged();
    } catch { toast('Error al agregar la fecha.', 'error'); }
    setSavingNuevaFecha(false);
  };

  const handleGuardarCupos = async (fechaId) => {
    const valor = cuposDraft[fechaId];
    try {
      await actualizarCuposFechaVuelo(fechaId, valor === '' ? null : valor);
      toast('Cupos actualizados ✅');
      onChanged();
    } catch { toast('Error al actualizar cupos.', 'error'); }
  };

  const MARGEN_MINIMO = 40;

  const handleGuardarPromo = async (fechaId) => {
    const valor = promoDraft[fechaId];
    if (valor !== '' && valor != null) {
      const precioPromo = parseFloat(valor);
      const costo = parseFloat(ruta.precio_base_usd);
      if (precioPromo <= costo) {
        toast(`No puedes poner $${precioPromo} — tu costo en esta ruta es $${costo}. Nunca por debajo del costo.`, 'error');
        return;
      }
      if (precioPromo < costo + MARGEN_MINIMO) {
        const margen = (precioPromo - costo).toFixed(0);
        if (!window.confirm(`Ese precio te deja solo $${margen} de margen sobre tu costo ($${costo}) — menos de tu piso de $${MARGEN_MINIMO}. ¿Guardar de todas formas?`)) {
          return;
        }
      }
    }
    try {
      await actualizarPrecioPromoFechaVuelo(fechaId, valor === '' ? null : valor);
      toast(valor === '' ? 'Promo quitada ✅' : 'Precio promo actualizado ✅');
      onChanged();
    } catch { toast('Error al actualizar el precio promo.', 'error'); }
  };

  const handleGuardarCuposPromo = async (fechaId) => {
    const valor = cuposPromoDraft[fechaId];
    const dias = diasPromoDraft[fechaId];
    try {
      await actualizarCuposPromoFechaVuelo(fechaId, valor === '' ? null : valor, dias === '' ? null : dias);
      toast('Cupos de oferta actualizados ✅');
      onChanged();
    } catch { toast('Error al actualizar cupos de oferta.', 'error'); }
  };

  const handleEliminarFecha = async (fechaId, fechaTexto) => {
    if (!window.confirm(`¿Eliminar la fecha ${fechaTexto}? Esto la borra del todo, no se puede deshacer.`)) return;
    try {
      await eliminarFechaVuelo(fechaId);
      toast('Fecha eliminada ✅');
      onChanged();
    } catch { toast('Error al eliminar la fecha.', 'error'); }
  };

  return (
    <div style={{ background: 'var(--navy-card)', border: `1px solid ${ruta.activa ? 'var(--navy-border)' : 'rgba(255,68,85,0.3)'}`, borderRadius: 14, padding: 16, marginBottom: 10, opacity: ruta.activa ? 1 : 0.6 }}>
      <button
        onClick={() => setAbierta((v) => !v)}
        style={{ display: 'flex', width: '100%', alignItems: 'center', gap: 10, background: 'none', border: 'none', padding: 0, textAlign: 'left', cursor: 'pointer', marginBottom: abierta ? 12 : 0 }}
      >
        <span style={{ fontSize: 12, fontWeight: 800, color: 'var(--orange)', background: 'var(--navy)', border: '1px solid var(--orange)', borderRadius: 8, padding: '3px 8px', whiteSpace: 'nowrap' }}>#{ruta.numero_visible}</span>
        <span style={{ flex: 1, minWidth: 0 }}>
          <span style={{ display: 'block', fontSize: 14, fontWeight: 700, color: 'var(--white)' }}>
            {[ruta.ciudad_salida, ruta.destino, ruta.aerolinea].filter(Boolean).join(' → ')}
          </span>
          <span style={{ display: 'block', fontSize: 11, color: 'var(--muted)', marginTop: 2 }}>
            {ruta.proveedor_nombre} · {ruta.escala || 'Directo'} · Zelle ${ruta.precio_zelle}{ruta.solo_usd_cuba ? ' · solo USD' : ''} · {ruta.fechas.length} fecha{ruta.fechas.length === 1 ? '' : 's'}{ruta.activa ? '' : ' · ⛔ inactiva'}
          </span>
        </span>
        <span style={{ fontSize: 16, color: 'var(--muted)' }}>{abierta ? '▲' : '▼'}</span>
      </button>
      {abierta && (<>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 10 }}>
        <div>
          <p style={{ fontSize: 14, fontWeight: 700, color: 'var(--white)' }}>{[ruta.destino, ruta.aerolinea].filter(Boolean).join(' · ')}</p>
          <p style={{ fontSize: 11, color: 'var(--muted)', marginTop: 2 }}>{ruta.proveedor_nombre} · {ruta.escala || 'Directo'}{ruta.frecuencia ? ` · ${ruta.frecuencia}` : ''}</p>
          <p style={{ fontSize: 12, color: 'var(--gold)', fontWeight: 700, marginTop: 4 }}>Zelle ${ruta.precio_zelle}</p>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6, alignItems: 'flex-end' }}>
          <button onClick={handleToggleActiva} disabled={savingActiva} style={{
            fontSize: 11, fontWeight: 700, borderRadius: 20, padding: '6px 12px', whiteSpace: 'nowrap',
            background: ruta.activa ? 'rgba(0,196,140,0.15)' : 'rgba(255,68,85,0.15)',
            color: ruta.activa ? 'var(--success)' : 'var(--error)',
            border: `1px solid ${ruta.activa ? 'rgba(0,196,140,0.4)' : 'rgba(255,68,85,0.4)'}`,
          }}>{ruta.activa ? '✅ Activa' : '⛔ Inactiva'}</button>
          <button
            onClick={handleToggleUsdCuba} disabled={savingUsdCuba}
            title="Si el cliente no puede recibir el pago en USD dentro de Cuba en esta ruta (ej. Sky High desde La Habana), apágalo aquí para que ese precio no se muestre."
            style={{
              fontSize: 11, fontWeight: 700, borderRadius: 20, padding: '6px 12px', whiteSpace: 'nowrap',
              background: ruta.admite_usd_cuba ? 'rgba(255,184,0,0.15)' : 'var(--navy-card)',
              color: ruta.admite_usd_cuba ? 'var(--gold)' : 'var(--muted)',
              border: `1px solid ${ruta.admite_usd_cuba ? 'rgba(255,184,0,0.4)' : 'var(--navy-border)'}`,
            }}>{ruta.admite_usd_cuba ? '💵 USD Cuba visible' : '🚫 USD Cuba oculto'}</button>
          <button
            onClick={handleToggleSoloUsd} disabled={savingSoloUsd}
            title="Si lo activas, el cliente ve esta ruta SOLO con el precio en USD (efectivo en Cuba): sin Zelle, reales, euros ni pesos. El precio es el de Zelle de cada fecha más el % de USD Cuba del proveedor (redondeado)."
            style={{
              fontSize: 11, fontWeight: 700, borderRadius: 20, padding: '6px 12px', whiteSpace: 'nowrap',
              background: ruta.solo_usd_cuba ? 'rgba(255,184,0,0.15)' : 'var(--navy-card)',
              color: ruta.solo_usd_cuba ? 'var(--gold)' : 'var(--muted)',
              border: `1px solid ${ruta.solo_usd_cuba ? 'rgba(255,184,0,0.4)' : 'var(--navy-border)'}`,
            }}>{ruta.solo_usd_cuba ? '💵 Solo USD: activado' : '💵 Solo USD: apagado'}</button>
          {!ruta.activa && (
            <button
              onClick={handleEliminarRuta} disabled={savingEliminar}
              title="Borra la ruta del todo (fechas incluidas). Solo disponible en rutas inactivas."
              style={{
                fontSize: 11, fontWeight: 700, borderRadius: 20, padding: '6px 12px', whiteSpace: 'nowrap',
                background: 'rgba(255,68,85,0.10)', color: 'var(--error)', border: '1px solid rgba(255,68,85,0.4)',
              }}>🗑️ Borrar ruta</button>
          )}
        </div>
      </div>

      <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
        <input value={equipaje} onChange={(e) => setEquipaje(e.target.value)} placeholder="Equipaje (ej: 1 maleta 23kg)" style={{ flex: 1 }} />
        <button onClick={handleGuardarEquipaje} disabled={savingEquipaje} style={{ background: 'var(--navy)', border: '1px solid var(--orange)', color: 'var(--orange)', borderRadius: 8, padding: '0 14px', fontSize: 12, fontWeight: 700 }}>💾</button>
      </div>

      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'center', marginBottom: 12 }}>
        <span style={{ fontSize: 10, color: 'var(--muted)', flex: '1 0 100%' }}>PRECIO</span>
        <div style={{ flex: '1 0 100px' }}>
          <label style={{ fontSize: 9, color: 'var(--muted)' }}>Costo (proveedor)</label>
          <input type="number" inputMode="decimal" value={precioBase} onChange={(e) => setPrecioBase(e.target.value)} style={{ width: '100%', padding: '6px 10px', fontSize: 12 }} />
        </div>
        <div style={{ flex: '1 0 100px' }}>
          <label style={{ fontSize: 9, color: 'var(--muted)' }}>Zelle (cliente)</label>
          <input type="number" inputMode="decimal" value={precioZelle} onChange={(e) => setPrecioZelle(e.target.value)} style={{ width: '100%', padding: '6px 10px', fontSize: 12 }} />
        </div>
        <button onClick={handleGuardarPrecio} disabled={savingPrecio} style={{ background: 'var(--navy)', border: '1px solid var(--orange)', color: 'var(--orange)', borderRadius: 8, padding: '6px 14px', fontSize: 12, fontWeight: 700, alignSelf: 'flex-end' }}>Guardar precio</button>
      </div>

      {(ruta.destino_categoria === 'mexico' || ruta.precio_zelle_ida_vuelta != null) && (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'center', marginBottom: 12 }}>
          <span style={{ fontSize: 10, color: 'var(--muted)', flex: '1 0 100%' }}>PRECIO IDA Y VUELTA (el de arriba es solo ida; vacío = sin precio de ida y vuelta)</span>
          <div style={{ flex: '1 0 100px' }}>
            <label style={{ fontSize: 9, color: 'var(--muted)' }}>Costo ida y vuelta</label>
            <input type="number" inputMode="decimal" value={precioBaseIdaVuelta} onChange={(e) => setPrecioBaseIdaVuelta(e.target.value)} style={{ width: '100%', padding: '6px 10px', fontSize: 12 }} />
          </div>
          <div style={{ flex: '1 0 100px' }}>
            <label style={{ fontSize: 9, color: 'var(--muted)' }}>Zelle ida y vuelta</label>
            <input type="number" inputMode="decimal" value={precioZelleIdaVuelta} onChange={(e) => setPrecioZelleIdaVuelta(e.target.value)} style={{ width: '100%', padding: '6px 10px', fontSize: 12 }} />
          </div>
          <button onClick={handleGuardarIdaVuelta} disabled={savingIdaVuelta} style={{ background: 'var(--navy)', border: '1px solid var(--orange)', color: 'var(--orange)', borderRadius: 8, padding: '6px 14px', fontSize: 12, fontWeight: 700, alignSelf: 'flex-end' }}>Guardar ida y vuelta</button>
        </div>
      )}

      {conNinos && (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'center', marginBottom: 12 }}>
          <span style={{ fontSize: 10, color: 'var(--muted)', flex: '1 0 100%' }}>PRECIO NIÑO / INFANTE</span>
          <div style={{ flex: '1 0 100px' }}>
            <label style={{ fontSize: 9, color: 'var(--muted)' }}>Costo niño (proveedor)</label>
            <input type="number" inputMode="decimal" value={precioBaseNino} onChange={(e) => setPrecioBaseNino(e.target.value)} style={{ width: '100%', padding: '6px 10px', fontSize: 12 }} />
          </div>
          <div style={{ flex: '1 0 100px' }}>
            <label style={{ fontSize: 9, color: 'var(--muted)' }}>Niño (cliente)</label>
            <input type="number" inputMode="decimal" value={precioNino} onChange={(e) => setPrecioNino(e.target.value)} style={{ width: '100%', padding: '6px 10px', fontSize: 12 }} />
          </div>
          <div style={{ flex: '1 0 100px' }}>
            <label style={{ fontSize: 9, color: 'var(--muted)' }}>Costo infante (proveedor)</label>
            <input type="number" inputMode="decimal" value={precioBaseInfante} onChange={(e) => setPrecioBaseInfante(e.target.value)} style={{ width: '100%', padding: '6px 10px', fontSize: 12 }} />
          </div>
          <div style={{ flex: '1 0 100px' }}>
            <label style={{ fontSize: 9, color: 'var(--muted)' }}>Infante (cliente)</label>
            <input type="number" inputMode="decimal" value={precioInfante} onChange={(e) => setPrecioInfante(e.target.value)} style={{ width: '100%', padding: '6px 10px', fontSize: 12 }} />
          </div>
          <button onClick={handleGuardarPrecioEdades} disabled={savingPrecioEdades} style={{ background: 'var(--navy)', border: '1px solid var(--orange)', color: 'var(--orange)', borderRadius: 8, padding: '6px 14px', fontSize: 12, fontWeight: 700, alignSelf: 'flex-end' }}>Guardar niño/infante</button>
        </div>
      )}

      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'center', marginBottom: 12 }}>
        <span style={{ fontSize: 10, color: 'var(--muted)', flex: '1 0 100%' }}>
          % DE USD CUBA DE ESTA RUTA (vacío = usa el {ruta.proveedor_porcentaje_usd_cuba}% del proveedor; con % propio el precio redondea hacia arriba al múltiplo de 5)
        </span>
        <div style={{ flex: '1 0 100px' }}>
          <input type="number" inputMode="decimal" step="0.1" placeholder={`${ruta.proveedor_porcentaje_usd_cuba} (proveedor)`} value={pctRuta} onChange={(e) => setPctRuta(e.target.value)} style={{ width: '100%', padding: '6px 10px', fontSize: 12 }} />
        </div>
        <button onClick={handleGuardarPctRuta} disabled={savingPct} style={{ background: 'var(--navy)', border: '1px solid var(--orange)', color: 'var(--orange)', borderRadius: 8, padding: '6px 14px', fontSize: 12, fontWeight: 700 }}>Guardar %</button>
      </div>

      <EscalonesBlock ruta={ruta} onChanged={onChanged} />

      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'center', marginBottom: 12 }}>
        <span style={{ fontSize: 10, color: 'var(--muted)', flex: '1 0 100%' }}>AGREGAR FECHA SUELTA</span>
        <input type="date" value={nuevaFecha} onChange={(e) => setNuevaFecha(e.target.value)} style={{ flex: '2 0 140px', padding: '6px 10px', fontSize: 12 }} />
        <input type="number" inputMode="numeric" placeholder="Cupos" value={nuevaFechaCupos} onChange={(e) => setNuevaFechaCupos(e.target.value)} style={{ flex: '1 0 80px', padding: '6px 10px', fontSize: 12 }} />
        <button onClick={handleAgregarFecha} disabled={savingNuevaFecha} style={{ background: 'rgba(0,196,140,0.12)', border: '1px solid var(--success)', color: 'var(--success)', borderRadius: 8, padding: '6px 14px', fontSize: 12, fontWeight: 700 }}>+ Agregar</button>
      </div>

      {ruta.fechas.length > 0 && (
        <div>
          <p style={{ fontSize: 10, color: 'var(--muted)', fontWeight: 700, letterSpacing: 0.5, marginBottom: 8 }}>FECHAS</p>
          {ruta.fechas.map((f) => {
            const restantesAhora = calcCuposPromoRestantes(f);
            const promoAgotada = f.precio_zelle_promo != null && restantesAhora === 0;
            return (
              <div key={f.id} style={{ border: '1px solid var(--navy-border)', borderRadius: 10, padding: 10, marginBottom: 8 }}>
                {/* Línea 1: cupo REAL -- lo que trae el mensaje del proveedor cada día */}
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'center', marginBottom: f.precio_zelle_promo != null || promoDraft[f.id] !== undefined ? 8 : 0 }}>
                  <span style={{ fontSize: 12, color: 'var(--off-white)', fontWeight: 700, flex: '1 0 90px' }}>{f.fecha}</span>
                  {ruta.escalonado && (
                    <span style={{
                      fontSize: 10, fontWeight: 700, borderRadius: 6, padding: '2px 6px',
                      color: f.precio_zelle_promo != null ? 'var(--orange)' : 'var(--muted)',
                      background: 'var(--navy)', border: '1px solid var(--navy-border)',
                    }} title={f.precio_zelle_promo != null ? 'Precio propio fijo' : 'Calculado por escalón'}>
                      {f.precio_zelle_promo != null ? '📌' : '📅'} ${calcPrecioZelleFecha(ruta, f)}
                    </span>
                  )}
                  <span style={{ fontSize: 9, color: 'var(--muted)', textTransform: 'uppercase', letterSpacing: 0.5 }}>Cupo real</span>
                  <input
                    type="number" inputMode="numeric" placeholder="Sin límite"
                    value={cuposDraft[f.id] !== undefined ? cuposDraft[f.id] : (f.cupos ?? '')}
                    onChange={(e) => setCuposDraft((d) => ({ ...d, [f.id]: e.target.value }))}
                    title="Cupo real de la aerolínea (lo actualiza el mensaje del proveedor)"
                    style={{ width: 80, padding: '6px 10px', fontSize: 12 }}
                  />
                  <button onClick={() => handleGuardarCupos(f.id)} style={{ background: 'var(--navy-card)', border: '1px solid var(--navy-border)', color: 'var(--muted)', borderRadius: 8, padding: '5px 10px', fontSize: 11 }}>Guardar</button>
                  <button
                    onClick={() => handleEliminarFecha(f.id, f.fecha)}
                    title="Eliminar esta fecha (ya pasó o dejó de ofrecerse)"
                    style={{ background: 'rgba(255,68,85,0.10)', border: '1px solid rgba(255,68,85,0.4)', color: 'var(--error)', borderRadius: 8, padding: '5px 10px', fontSize: 11, fontWeight: 700 }}
                  >🗑️ Eliminar fecha</button>
                </div>

                {/* Línea 2: OFERTA -- precio y cupos de marketing en filas separadas, cada uno con SU
                    propio botón pegado al lado, para que no se puedan confundir (bug real: se guardó
                    un precio en el campo de cupos por tener los dos botones juntos abajo de ambos campos). */}
                <p style={{ fontSize: 10, color: 'var(--orange)', fontWeight: 700, marginBottom: 6 }}>
                  🔥 Precio propio / oferta{promoAgotada ? ' · agotada' : ''}
                  <span style={{ color: 'var(--muted)', fontWeight: 400 }}> — deja "Cupos a mostrar" vacío para un precio fijo sin cuenta regresiva</span>
                </p>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'center', marginBottom: 6 }}>
                  <span style={{ fontSize: 10, color: 'var(--muted)', flex: '1 0 80px' }}>Precio Zelle</span>
                  <input
                    type="number" inputMode="decimal" placeholder="Sin promo"
                    value={promoDraft[f.id] !== undefined ? promoDraft[f.id] : (f.precio_zelle_promo ?? '')}
                    onChange={(e) => setPromoDraft((d) => ({ ...d, [f.id]: e.target.value }))}
                    title="Precio Zelle de oferta para esta fecha (vacío = sin promo). No lo toca el pegado diario."
                    style={{ width: 130, padding: '6px 10px', fontSize: 12, borderColor: f.precio_zelle_promo != null ? 'var(--orange)' : undefined }}
                  />
                  <button onClick={() => handleGuardarPromo(f.id)} style={{ background: 'rgba(255,107,0,0.12)', border: '1px solid var(--orange)', color: 'var(--orange)', borderRadius: 8, padding: '5px 10px', fontSize: 11, fontWeight: 700 }}>Guardar precio</button>
                </div>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'center' }}>
                  <span style={{ fontSize: 10, color: 'var(--muted)', flex: '1 0 80px' }}>Cupos a mostrar</span>
                  <input
                    type="number" inputMode="numeric" placeholder="Sin contador"
                    value={cuposPromoDraft[f.id] !== undefined ? cuposPromoDraft[f.id] : (f.cupos_promo ?? '')}
                    onChange={(e) => setCuposPromoDraft((d) => ({ ...d, [f.id]: e.target.value }))}
                    title="Cupos de oferta a mostrar (número de marketing, no tiene que coincidir con el cupo real). Vacío = sin contador visible."
                    style={{ width: 100, padding: '6px 10px', fontSize: 12 }}
                  />
                  <span style={{ fontSize: 10, color: 'var(--muted)' }}>en</span>
                  <input
                    type="number" inputMode="numeric" placeholder="Auto"
                    value={diasPromoDraft[f.id] !== undefined ? diasPromoDraft[f.id] : (f.promo_dias_duracion ?? '')}
                    onChange={(e) => setDiasPromoDraft((d) => ({ ...d, [f.id]: e.target.value }))}
                    title="En cuántos días exactos se agota (vacío = automático, ~3-5 días)"
                    style={{ width: 60, padding: '6px 10px', fontSize: 12 }}
                  />
                  <span style={{ fontSize: 10, color: 'var(--muted)' }}>días</span>
                  <button onClick={() => handleGuardarCuposPromo(f.id)} style={{ background: 'rgba(255,107,0,0.12)', border: '1px solid var(--orange)', color: 'var(--orange)', borderRadius: 8, padding: '5px 10px', fontSize: 11, fontWeight: 700 }}>Guardar cupos</button>
                </div>
                {f.precio_zelle_promo != null && f.cupos_promo != null && (
                  <p style={{ fontSize: 10.5, color: 'var(--muted)', marginTop: 6 }}>
                    → el cliente está viendo ahora mismo: <strong style={{ color: promoAgotada ? 'var(--error)' : 'var(--orange)' }}>
                      {promoAgotada ? 'oferta agotada, precio normal' : `quedan ${restantesAhora}`}
                    </strong> (baja solo con los días, no hace falta que lo actualices)
                  </p>
                )}
              </div>
            );
          })}
        </div>
      )}
      </>)}
    </div>
  );
}

export default function VuelosRutasPublicadas() {
  const [rutas, setRutas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [busqueda, setBusqueda] = useState('');

  // Solo la primera carga muestra "Cargando..." (desmonta la lista). Las recargas tras
  // guardar/eliminar son silenciosas para que el admin se quede en el mismo lugar.
  const cargar = async () => {
    const data = await getRutasAdmin();
    // Número fijo por ruta (columna `numero`); si la migración aún no corrió, se calcula por antigüedad.
    const porAntiguedad = [...data].sort((a, b) => String(a.created_at).localeCompare(String(b.created_at)));
    const fallback = new Map(porAntiguedad.map((r, i) => [r.id, i + 1]));
    setRutas(data.map((r) => ({ ...r, numero_visible: r.numero ?? fallback.get(r.id) })));
    setLoading(false);
  };

  useEffect(() => { cargar(); }, []);

  if (loading) return <p style={{ color: 'var(--muted)', textAlign: 'center', padding: 20 }}>Cargando rutas...</p>;
  if (rutas.length === 0) return <p style={{ color: 'var(--muted)', textAlign: 'center', padding: 20 }}>No hay rutas publicadas todavía.</p>;

  const busquedaKey = normalizeKey(busqueda);
  // "12" o "#12" -> solo esa ruta. Texto -> todas las palabras deben aparecer (ej: "habana aruba").
  const numeroBuscado = /^#?\d+$/.test(busqueda.trim()) ? parseInt(busqueda.trim().replace('#', ''), 10) : null;
  const tokens = busqueda.trim().split(/\s+/).map(normalizeKey).filter(Boolean);
  const rutasFiltradas = !busquedaKey ? rutas : numeroBuscado != null
    ? rutas.filter((r) => r.numero_visible === numeroBuscado)
    : rutas.filter((r) => {
      const texto = normalizeKey([r.aerolinea, r.ciudad_salida, r.destino, r.escala, r.proveedor_nombre].filter(Boolean).join(' '));
      return tokens.every((t) => texto.includes(t));
    });

  const porCategoria = {};
  rutasFiltradas.forEach((r) => {
    const cat = r.destino_categoria || 'guyana';
    if (!porCategoria[cat]) porCategoria[cat] = [];
    porCategoria[cat].push(r);
  });

  return (
    <div>
      <input
        value={busqueda}
        onChange={(e) => setBusqueda(e.target.value)}
        placeholder="🔎 Número de ruta (ej: 12) o texto (ej: Habana Aruba)"
        style={{ marginBottom: 18 }}
      />
      {busquedaKey && rutasFiltradas.length === 0 && (
        <p style={{ color: 'var(--muted)', textAlign: 'center', padding: 20 }}>
          Ninguna ruta coincide con "{busqueda}".
        </p>
      )}
      {DESTINO_CATEGORIAS.filter((cat) => porCategoria[cat.id]?.length > 0).map((cat) => {
        const porCiudad = {};
        porCategoria[cat.id].forEach((r) => {
          if (!porCiudad[r.ciudad_salida]) porCiudad[r.ciudad_salida] = [];
          porCiudad[r.ciudad_salida].push(r);
        });

        return (
          <div key={cat.id} style={{ marginBottom: 28 }}>
            <p style={{ fontSize: 15, fontWeight: 800, color: 'var(--white)', marginBottom: 12 }}>{cat.icon} {cat.label}</p>
            {Object.entries(porCiudad).map(([ciudad, lista]) => (
              <div key={ciudad} style={{ marginBottom: 16 }}>
                <p className="section-label">🛫 {ciudad}</p>
                {lista.map((r) => <RutaRow key={r.id} ruta={r} onChanged={cargar} abiertaInicial={rutasFiltradas.length === 1 && !!busquedaKey} />)}
              </div>
            ))}
          </div>
        );
      })}
    </div>
  );
}
